export default "__VITE_ASSET__Cvow_9cc__"